// import { useState, useContext, ReactNode, useEffect } from 'react';
// import { useNavigate } from 'react-router-dom';
// import { useTranslation } from 'react-i18next';
// import classNames from 'classnames';
// import { useWindowSize } from 'react-use';
// import { demoPagesMenu } from '../../menu';
// import { DropdownItem, DropdownMenu } from '../../components/bootstrap/Dropdown';
// import Button from '../../components/bootstrap/Button';
// import Collapse from '../../components/bootstrap/Collapse';
// import Icon from '../../components/icon/Icon';
// import useNavigationItemHandle from '../../hooks/useNavigationItemHandle';
// import ThemeContext from '../../contexts/themeContext';
// import UserImage6Webp from '../../assets/img/wanna/wanna6.webp';
// import UserImage6WebpMale from '../../assets/img/wanna/wanna3.webp';

// const User = () => {
// 	const { width } = useWindowSize();
// 	const { setAsideStatus } = useContext(ThemeContext);
// 	const navigate = useNavigate();
// 	const [collapseStatus, setCollapseStatus] = useState<boolean>(false);
// 	const { t } = useTranslation(['translation', 'menu']);
// 	const [userData, setUserData] = useState({
// 		id: '',
// 		first_name: '',
// 		last_name: '',
// 		designation: {
// 			name: '',
// 		},
// 		gender: '',
// 	});

// 	useEffect(() => {
// 		if (localStorage.getItem('userData') != '' && localStorage.getItem('userData') != null) {
// 			setUserData(JSON.parse(localStorage.getItem('userData') || ''));
// 		}
// 	}, []);

// 	return (
// 		<>
// 			<div
// 				className={classNames('user', { open: collapseStatus })}
// 				role='presentation'
// 				onClick={() => setCollapseStatus(!collapseStatus)}>
// 				<div className='user-avatar'>
// 					<img
// 						srcSet={userData?.gender == 'Female' ? UserImage6Webp : UserImage6WebpMale}
// 						// src={UserImage6}
// 						alt='Avatar'
// 						width={128}
// 						height={128}
// 					/>
// 				</div>
// 				<div className='user-info'>
// 					<div
// 						className='user-name d-flex align-items-center'
// 						style={{
// 							color: '#FFFFFF',
// 							fontSize: '15px',
// 						}}>
// 						{`${userData.first_name + ' ' + userData.last_name}`}
// 						{/* <Icon icon='Verified' className='ms-1' color='info' /> */}
// 					</div>
// 					<div
// 						className='user-sub-title'
// 						style={{
// 							color: '#FFFFFF',
// 							fontSize: '14px',
// 						}}>{`${userData.designation.name}`}</div>
// 				</div>
// 			</div>
// 			<DropdownMenu>
// 				<DropdownItem>
// 					<Button icon='AccountBox'>Profile</Button>
// 				</DropdownItem>
// 			</DropdownMenu>
// 			<Collapse isOpen={collapseStatus} className='user-menu'>
// 				<nav aria-label='aside-bottom-user-menu-2'>
// 					<div className='navigation'>
// 						<div
// 							role='presentation'
// 							className='navigation-item cursor-pointer'
// 							onClick={() => {
// 								if (userData) {
// 									localStorage.removeItem('userData');
// 								}
// 								if (width < Number(process.env.REACT_APP_MOBILE_BREAKPOINT_SIZE)) {
// 									setAsideStatus(false);
// 								}
// 								navigate(`../${demoPagesMenu.login.path}`);
// 							}}>
// 							<span className='navigation-link navigation-link-pill'>
// 								<span className='navigation-link-info'>
// 									<Icon icon='Logout' className='navigation-icon' />
// 									<span className='navigation-text'>
// 										{t('menu:Logout') as ReactNode}
// 									</span>
// 								</span>
// 							</span>
// 						</div>
// 					</div>
// 				</nav>
// 			</Collapse>
// 		</>
// 	);
// };

// export default User;

import { useState, useContext, ReactNode, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import { useWindowSize } from 'react-use';
import { demoPagesMenu } from '../../menu';
import { DropdownItem, DropdownMenu } from '../../components/bootstrap/Dropdown';
import Button from '../../components/bootstrap/Button';
import Collapse from '../../components/bootstrap/Collapse';
import Icon from '../../components/icon/Icon';
import ThemeContext from '../../contexts/themeContext';
import UserImage6Webp from '../../assets/img/wanna/wanna6.webp';
import UserImage6WebpMale from '../../assets/img/wanna/wanna3.webp';
import 'bootstrap/dist/js/bootstrap.bundle.min';

const User = () => {
	const { width } = useWindowSize();
	const { setAsideStatus } = useContext(ThemeContext);
	const navigate = useNavigate();
	const { t } = useTranslation(['translation', 'menu']);
	const [collapseStatus, setCollapseStatus] = useState<boolean>(false);
	const [showModal, setShowModal] = useState(false);

	const [userData, setUserData] = useState({
		id: '',
		first_name: '',
		last_name: '',
		designation: {
			name: '',
		},
		gender: '',
	});

	const [form, setForm] = useState({
		currentPassword: '',
		newPassword: '',
		confirmNewPassword: '',
	});
	const [error, setError] = useState('');

	useEffect(() => {
		if (localStorage.getItem('userData') != '' && localStorage.getItem('userData') != null) {
			setUserData(JSON.parse(localStorage.getItem('userData') || ''));
		}
	}, []);

	const handlePasswordChange = async (e: React.FormEvent) => {
		e.preventDefault();

		if (form.newPassword !== form.confirmNewPassword) {
			setError('New passwords do not match.');
			return;
		}
		if (form.currentPassword === form.newPassword) {
			setError('New password cannot be the same as the current password.');
			return;
		}
		try {
			const response = await fetch(
				process.env.REACT_APP_NODEJS_URL + 'company/change-password',
				{
					method: 'POST',
					headers: {
						'Content-Type': 'application/json',
					},
					body: JSON.stringify({
						userId: userData?.id,
						currentPassword: form.currentPassword,
						newPassword: form.newPassword,
					}),
				},
			);
			const data = await response.json();
			if (!response.ok) {
				throw new Error(data.message || 'Failed to change password');
			}
			alert('Password changed successfully!');
			localStorage.removeItem('userData');
			navigate(`../${demoPagesMenu.login.path}`);
		} catch (error: any) {
			setError(error.message);
		}
	};

	return (
		<>
			<div
				className={classNames('user', { open: collapseStatus })}
				role='presentation'
				onClick={() => setCollapseStatus(!collapseStatus)}>
				<div className='user-avatar'>
					<img
						srcSet={userData?.gender === 'Female' ? UserImage6Webp : UserImage6WebpMale}
						alt='Avatar'
						width={128}
						height={128}
					/>
				</div>
				<div className='user-info'>
					<div
						className='user-name d-flex align-items-center'
						style={{ color: '#FFFFFF', fontSize: '15px' }}>
						{`${userData.first_name} ${userData.last_name}`}
					</div>
					<div className='user-sub-title' style={{ color: '#FFFFFF', fontSize: '14px' }}>
						{userData.designation.name}
					</div>
				</div>
			</div>

			<DropdownMenu>
				<DropdownItem>
					<Button icon='AccountBox'>Profile</Button>
				</DropdownItem>
			</DropdownMenu>

			<Collapse isOpen={collapseStatus} className='user-menu'>
				<nav aria-label='aside-bottom-user-menu-2'>
					<div className='navigation'>
						{/* {userData.designation.name == 'SuperAdmin' ||
						userData.designation.name == 'superadmin' ||
						userData.designation.name == 'Super Admin' ? (
							<></>
						) : (
							<div
								role='presentation'
								className='navigation-item cursor-pointer'
								onClick={() => {
									navigate('/change-password');
									// setShowModal(true)
								}}>
								<span className='navigation-link navigation-link-pill'>
									<span className='navigation-link-info'>
										<Icon
											icon='Lock'
											className='me-2'
											style={{ fontSize: '1.5rem' }}
										/>
										<span className='navigation-text'>Change Password</span>
									</span>
								</span>
							</div>
						)} */}
						<div
							role='presentation'
							className='navigation-item cursor-pointer'
							onClick={() => {
								localStorage.removeItem('userData');
								if (width < Number(process.env.REACT_APP_MOBILE_BREAKPOINT_SIZE)) {
									setAsideStatus(false);
								}
								navigate(`../${demoPagesMenu.login.path}`);
							}}>
							<span className='navigation-link navigation-link-pill'>
								<span className='navigation-link-info'>
									<Icon icon='Logout' className='navigation-icon' />
									<span className='navigation-text'>
										{t('menu:Logout') as ReactNode}
									</span>
								</span>
							</span>
						</div>
					</div>
				</nav>
			</Collapse>

			{/* 🔽 Bootstrap Modal */}
			<div
				className={`modal fade ${showModal ? 'show d-block' : ''}`}
				tabIndex={-1}
				role='dialog'>
				<div className='modal-dialog' role='document'>
					<div className='modal-content'>
						<div
							className='modal-header'
							style={{
								backgroundColor: '#f8f9fa',
								padding: '15px',
								borderBottom: '1px solid #dee2e6',
							}}>
							<h5
								className='modal-title'
								style={{ fontSize: '18px', fontWeight: 'bold', color: '#333' }}>
								<Icon
									icon='Lock'
									className='me-2'
									style={{ fontSize: '1.5rem', color: '#007bff' }}
								/>
								Change Password
							</h5>
							<button
								type='button'
								className='btn-close'
								onClick={() => setShowModal(false)}
							/>
						</div>
						<form onSubmit={handlePasswordChange}>
							<div className='modal-body'>
								{error && <div className='alert alert-danger'>{error}</div>}
								<div className='mb-3'>
									<label htmlFor='currentPassword' className='form-label'>
										Current Password <span style={{ color: 'red' }}>*</span>
									</label>
									<input
										type='password'
										className='form-control'
										id='currentPassword'
										value={form.currentPassword}
										onChange={(e) =>
											setForm({ ...form, currentPassword: e.target.value })
										}
										required
									/>
								</div>
								<div className='mb-3'>
									<label htmlFor='newPassword' className='form-label'>
										New Password <span style={{ color: 'red' }}>*</span>
									</label>
									<input
										type='password'
										className='form-control'
										id='newPassword'
										value={form.newPassword}
										onChange={(e) =>
											setForm({ ...form, newPassword: e.target.value })
										}
										required
									/>
								</div>
								<div className='mb-3'>
									<label htmlFor='confirmNewPassword' className='form-label'>
										Confirm New Password <span style={{ color: 'red' }}>*</span>
									</label>
									<input
										type='password'
										className='form-control'
										id='confirmNewPassword'
										value={form.confirmNewPassword}
										onChange={(e) =>
											setForm({ ...form, confirmNewPassword: e.target.value })
										}
										required
									/>
								</div>
							</div>
							<div className='modal-footer'>
								<button
									type='button'
									className='btn btn-secondary'
									onClick={() => setShowModal(false)}>
									Cancel
								</button>
								<button type='submit' className='btn btn-primary'>
									Change Password
								</button>
							</div>
						</form>
					</div>
				</div>
			</div>
			{showModal && <div className='modal-backdrop fade show'></div>}
		</>
	);
};

export default User;
